import { Notifiable } from '@app/types/core.types';
import api from '../api';
import { Redirect } from 'react-router';

export interface Encerramento {
  id: string;
  observacao: string;
  contratoId: string;
  statusEncerramento: string;
  statusEncerramentoCodigo?: number;

  dataHoraInicioProcesso?: Date;
  dataHoraEncerramentoProcesso?: Date;

  dataUploadTRP?: Date;
  responsavelTRP?: string;
  observacaoTRP?: string;
  nomeArquivoTRP?: string;
  localArquivoTRP?: string;

  dataUploadTRD?: Date;
  responsavelTRD?: string;
  observacaoTRD?: string;
  nomeArquivoTRD?: string;
  localArquivoTRD?: string;

  dataUploadNadaConsta?: Date;
  responsavelNadaConsta?: string;
  observacaoNadaConsta?: string;
  nomeArquivoNadaConsta?: string;
  localArquivoNadaConsta?: string;

  dataUploadTEQCAssinado?: Date;
  responsavelTEQCAssinado?: string;
  observacaoTEQCAssinado?: string;
  nomeArquivoTEQCAssinado?: string;
  localArquivoTEQCAssinado?: string;

  seraAditado?: boolean;
  dataInicioAdicao?: Date;
  responsavelAdicao?: string;
  responsavelInicioEncerramento?: string;
}

export const getEncerramento = (contratoId: any) => api.get<Encerramento>(`encerramentos/contrato/${contratoId}`);
export const iniciarAdicao = (id: string) => api.post('contratos/IniciarAdicao', { id });

export const updateEncerramentoComArquivo = (file: any, Encerramento: Encerramento, codigoSolicitacao: number) => {
  const form = new FormData();
  Object.keys(Encerramento).forEach(key => {
    form.append(key, Encerramento[key]);
  });
  form.append('file', file);

  return api.put(`encerramentos/contrato?CodigoSolicitacao=${codigoSolicitacao}`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateEncerramento = (Encerramento: Encerramento, codigoSolicitacao: number) =>
  api.put(`encerramentos/contrato?CodigoSolicitacao=${codigoSolicitacao}`, Encerramento);

export const updateObservacao = (values: any) => api.post(`encerramentos/updateObservacao`, values);

export const removerArquivoEncerramento = (ContratoId: string, codigoSolicitacao: number) => {
  let data = { ContratoId: ContratoId };
  return api.put(`encerramentos/contrato/removerArquivo?CodigoSolicitacao=${codigoSolicitacao}`, data);
};

export const iniciarProcessoEncerramento = (contratoId: any, justificativa?: string) =>
  api.put(
    'encerramentos/contrato/IniciarProcesso',
    { ContratoId: contratoId, Justificativa: justificativa },
    // { disableNotification: 'true' }
  );

export const urlDownloadEncerramento = '/api/encerramentos/contrato/download?path=';
